<template>
    <div class="flex items-center gap-2">
        <a
            v-if="
                [
                    TaskType.EXPORT_CSV,
                    TaskType.EXPORT_XLSX,
                    TaskType.EXPORT_INTEREST_PAYMENT_SEPA_CSV,
                    TaskType.EXPORT_INTEREST_PAYMENT_EXCEL,
                    TaskType.EXPORT_SIGNED_DOCUMENTS,
                    TaskType.EXPORT_INVESTOR_KYC_FOLDER,
                ].includes(rowData.type) && rowData.result_data?.download_url
            "
            :href="rowData.result_data?.download_url"
            class="bg-primary-additional-500 max-w-xs truncate rounded p-2 text-xs text-white"
            >{{ rowData.result_data.filename }}</a
        >
        <div v-if="typeof rowData.result_data?.totalCount === 'number'">
            {{ $t('total_count') }}
            <Badge type="info">{{ rowData.result_data?.totalCount }}</Badge>
        </div>
        <div v-if="typeof rowData.result_data?.errorCount === 'number'">
            {{ $t('error_count') }}
            <Badge type="error">{{ rowData.result_data?.errorCount }}</Badge>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Badge } from '@src/components'
import { TaskType } from '@src/enums'
import { Task } from '@src/types'

defineProps<{
    rowData: Task
}>()
</script>

<style scoped></style>
